import React, { cloneElement, Component } from 'react';
import classNames from 'classnames';
import Input from './Input';
import Button from '../button';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
import Icon from '../icon';
export default class Search extends Component {
    constructor() {
        super(...arguments);
        this.onSearch = (e) => {
            const { onSearch } = this.props;
            if (onSearch) {
                onSearch(this.input.input.value, e);
            }
            this.input.focus();
        };
        this.saveInput = (node) => {
            this.input = node;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    focus() {
        this.input.focus();
    }
    blur() {
        this.input.blur();
    }
    getPrefixCls() {
        const { prefixCls } = this.props;
        const { getPrefixCls } = this.context;
        return getPrefixCls('input-search', prefixCls);
    }
    getButtonOrIcon(prefixCls) {
        const { enterButton, size, disabled, buttonProps } = this.props;
        if (!enterButton) {
            return React.createElement(Icon, { className: `${prefixCls}-icon`, type: "search", key: "searchIcon", onClick: this.onSearch });
        }
        const enterButtonAsElement = enterButton;
        const isButton = enterButtonAsElement.type && (enterButtonAsElement.type.__C7N_BUTTON === true || enterButtonAsElement.type.__PRO_BUTTON === true || enterButtonAsElement.type.__ANT_BUTTON === true);
        if (isButton || enterButtonAsElement.type === 'button') {
            return cloneElement(enterButtonAsElement, isButton ? {
                className: `${prefixCls}-button`,
                size,
                onClick: (e) => {
                    if (enterButtonAsElement) {
                        const { props } = enterButtonAsElement;
                        if (props && props.onClick) {
                            props.onClick(e);
                        }
                    }
                    this.onSearch(e);
                },
            } : {
                onClick: this.onSearch,
            });
        }
        return (React.createElement(Button, Object.assign({}, buttonProps, { className: `${prefixCls}-button`, type: "primary", size: size, disabled: disabled, key: "enterButton", icon: enterButton === true || !enterButton ? 'search' : undefined, onClick: this.onSearch }), enterButton === true ? undefined : enterButton));
    }
    render() {
        const { className, inputPrefixCls, size, suffix, enterButton, ...others } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = this.getPrefixCls();
        delete others.onSearch;
        delete others.prefixCls;
        const buttonOrIcon = this.getButtonOrIcon(prefixCls);
        const searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
        const inputClassName = classNames(prefixCls, className, {
            [`${prefixCls}-enter-button`]: !!enterButton,
            [`${prefixCls}-${size}`]: !!size,
        });
        return (React.createElement(Input, Object.assign({ onPressEnter: this.onSearch }, others, { size: size, className: inputClassName, prefixCls: getPrefixCls('input', inputPrefixCls), suffix: searchSuffix, ref: this.saveInput })));
    }
}
Search.displayName = 'Search';
Search.defaultProps = {
    enterButton: true,
    size: Size.small,
};
